import { InputForm } from "../types";

export const ADMIN_COLUMNS = [
    {
        field: 'role',
        headerName: 'User Role',
        width: 250
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 150,
    },
    {
        field: 'fullname',
        headerName: 'User Name',
        width: 250,
    },
    {
        field: 'customerName',
        headerName: 'Customer',
        width: 250,
    },
    {
        field: 'teams',
        headerName: 'Teams',
        width: 300,
    },
    
    {
        field: 'invite',
        headerName: 'Invite Status',
        width: 100
    },
    {
        field: 'active',
        headerName: 'User Access Status',
        width: 100
    },
    {
        field: 'createdAt',
        headerName: 'Created At',
        width: 250,
    },
    {
        field: 'lastActive',
        headerName: 'Last Login',
        width: 250,
    },
];

export const INVITE_ADMIN_USER_FORM_INPUTS: InputForm[] = [
    {
        label: 'Full Name',
        id: 'fullname',
        type: 'text',
        required: true,
        placeholder: 'Insert the name of the admin user',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },
    {
        label: 'User email',
        id: 'email',
        type: 'email',
        required: true,
        placeholder: 'Insert the user email',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
    {
        label: 'Phone Number',
        id: 'phone',
        type: 'text',
        mask: '+1 (999) 999-9999',
        required: true,
        placeholder: 'Insert the user phone number',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
];

export const SET_PHONE_INPUTS: InputForm[] = [
    {
        label: 'Phone Number',
        id: 'phone',
        type: 'number',
        required: true,
        placeholder: 'Type your phone number',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },
]

export const ADMIN_LOCATION_ADDRESS_INPUTS: InputForm[] = [
    {
        label: 'Address',
        id: 'address',
        type: 'text',
        required: true,
        placeholder: 'Type the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },
    {
        label: 'City',
        id: 'city',
        type: 'text',
        required: true,
        placeholder: 'Type the city',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },
    {
        label: 'State',
        id: 'state',
        type: 'text',
        required: true,
        placeholder: 'Type the state of the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },

    {
        label: 'Zipcode',
        id: 'zip',
        type: 'text',
        required: true,
        placeholder: 'Type the zipcode of the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 12,
        },
    },
];
  

export const SYSTEM_USER_HOME_LOCATION_ADDRESS_INPUTS: InputForm[] = [
    {
        label: 'Address',
        id: 'homeLocation.address',
        type: 'text',
        required: false,
        placeholder: 'Type the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
    {
        label: 'City',
        id: 'homeLocation.city',
        type: 'text',
        required: false,
        placeholder: 'Type the city',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
    {
        label: 'State',
        id: 'homeLocation.state',
        type: 'text',
        required: false,
        placeholder: 'Type the state of the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
    {
        label: 'Zipcode',
        id: 'homeLocation.zip',
        type: 'text',
        required: false,
        placeholder: 'Type the zipcode of the address',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
    },
];

export const SYSTEM_USER_FILTER_INPUTS: InputForm[] = [
    {
        label: 'User Name',
        id: 'fullname',
        type: 'text',
        required: false,
        placeholder: 'Filter by user name',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
    {
        label: 'Email',
        id: 'email',
        type: 'text',
        required: false,
        placeholder: 'Filter by email',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
    {
        label: 'Teams',
        id: 'teams',
        type: 'text',
        required: false,
        placeholder: 'Filter by team assignments',
        grid: {
            xs: 4,
            sm: 4,
            md: 4,
        },
    },
];

export const SYSTEM_USER_TEAM_ASSIGNMENT_INPUTS: InputForm[] = [
    {
        label: 'Teams',
        id: 'teamIds',
        type: 'select',
        isMultiple: true,
        required: false,
        placeholder: 'Select teams to assign',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
        description: 'Select teams this user will manage (Team Leader, Group Leader, Admin, and Super Admin roles only)',
        options: [], // Will be populated dynamically
    },
    {
        label: 'Groups',
        id: 'groupIds',
        type: 'select',
        isMultiple: true,
        required: false,
        placeholder: 'Select groups to assign',
        grid: {
            xs: 12,
            sm: 12,
            md: 6,
        },
        description: 'Select groups this user will manage (Group Leader, Admin, and Super Admin roles only)',
        options: [], // Will be populated dynamically
    },
];
